import Anthropic from '@anthropic-ai/sdk';
import { ChatMessage, NetworkContext } from '../types';
import { SYSTEM_PROMPT, buildContextPrompt } from '../prompts/system-prompt';

export class AnthropicProvider {
  private client: Anthropic;
  private model: string;

  constructor() {
    // TEMPORARY: Hardcoded for local demo
    // TODO: Move to .env.local for production
    const apiKey = process.env.REACT_APP_ANTHROPIC_API_KEY || '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';

    this.client = new Anthropic({
      apiKey,
      dangerouslyAllowBrowser: true,
    });

    // Available models: claude-opus-4-20250514, claude-sonnet-4-20250514, claude-3-5-haiku-20241022
    this.model = 'claude-opus-4-20250514'; // Using Opus 4 for best quality
  }

  async chat(messages: ChatMessage[], context: NetworkContext): Promise<string> {
    const systemPrompt = SYSTEM_PROMPT + '\n\n' + buildContextPrompt(context);

    const response = await this.client.messages.create({
      model: this.model,
      max_tokens: 4096,
      system: systemPrompt,
      messages: messages.map((m) => ({
        role: m.role as 'user' | 'assistant',
        content: m.content,
      })),
    });

    const textBlock = response.content.find((block) => block.type === 'text');
    return textBlock?.type === 'text' ? textBlock.text : 'No response generated.';
  }

  // Method with streaming for long responses
  async chatStream(
    messages: ChatMessage[],
    context: NetworkContext,
    onChunk: (chunk: string) => void
  ): Promise<string> {
    const systemPrompt = SYSTEM_PROMPT + '\n\n' + buildContextPrompt(context);

    const stream = await this.client.messages.stream({
      model: this.model,
      max_tokens: 4096,
      system: systemPrompt,
      messages: messages.map((m) => ({
        role: m.role as 'user' | 'assistant',
        content: m.content,
      })),
    });

    let fullResponse = '';

    for await (const event of stream) {
      if (event.type === 'content_block_delta' && event.delta.type === 'text_delta') {
        const text = event.delta.text;
        fullResponse += text;
        onChunk(text);
      }
    }

    return fullResponse;
  }
}

